import { render } from "./Trajectory.vue?vue&type=template&id=a0bf9f14"
import script from "./Trajectory.vue?vue&type=script&lang=js"
export * from "./Trajectory.vue?vue&type=script&lang=js"

import "./Trajectory.vue?vue&type=style&index=0&id=a0bf9f14&lang=css"
script.render = render

export default script